import React, { useContext, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import avatar from "../../assets/images/avatar.svg";
import { Formik, Form } from "formik";
import Cookies from "js-cookie";
import { withRouter } from "react-router-dom";
import { ProfileSection } from "../../context/ProfileContext";
import {
  profileUpdateApi,
  profileImageUpdateApi,
  logoutAllApi,
} from "../../api";
import { updateProfileInfo } from "../../redux";
import { Alert } from "../";
import { useTranslation } from "react-i18next";
import { FiUser, FiPhone, FiMail, FiLogOut, FiArrowRight, FiCheck, FiCamera } from "react-icons/fi";

const EditProfileComp = (props) => {
  const { t } = useTranslation();
  const userInfo = useSelector((state) => state.userProfileInfo);
  let form = useRef();
  const token = Cookies.get("token");
  const dispatch = useDispatch();
  const [showAlert, setShowAlert] = useState({
    show: false,
    message: "",
    type: "",
  });
  
  const initialValues = {
    name: userInfo.name,
    phone: userInfo.phone,
  };

  const submitUpdateForm = (val) => {
    const data = new FormData(form.current);
    
    profileUpdateApi(data, token)
      .then(() => {
        ProfileShowHideFunc("firstPage");
        dispatch(updateProfileInfo({ name: val.name, phone: val.phone }));
        setShowAlert((prevState) => ({
          ...prevState,
          show: true,
          message: t("اطلاعات با موفقیت ذخیره شد"),
          type: "Success",
        }));
        setTimeout(() => {
          setShowAlert((prevState) => ({
            ...prevState,
            show: false,
          }));
        }, 2000);
      })
      .catch((err) => {
        if (err.response.status === 403) {
          Cookies.remove("token");
          props.history.push("/login");
        }
      });
  };

  const logoutAll = () => {
    logoutAllApi(token)
      .then((res) => {
        Cookies.remove("token");
        props.history.push("/login");
      })
      .catch((err) => console.log(err));
  };

  const { ProfileShowHideFunc } = useContext(ProfileSection);

  const imageSelected = (e) => {
    if (e.target.files && e.target.files[0]) {
      let img = e.target.files[0];

      const data = new FormData();
      data.append("image", img);
      profileImageUpdateApi(data, token)
        .then((res) => {
          dispatch(updateProfileInfo({ image: res.data.data }));

          setShowAlert((prevState) => ({
            ...prevState,
            show: true,
            message: t("عکس آپلود شد."),
            type: "Success",
          }));
          setTimeout(() => {
            setShowAlert((prevState) => ({
              ...prevState,
              show: false,
            }));
          }, 3000);
        })
        .catch((err) => {
          setShowAlert((prevState) => ({
            ...prevState,
            show: true,
            message: t("اندازه فایل مجاز نیست و یا نامعتبرست!"),
            type: "Error",
          }));
          setTimeout(() => {
            setShowAlert((prevState) => ({
              ...prevState,
              show: false,
            }));
          }, 3000);
          if (err.response.status === 403) {
            Cookies.remove("token");
            props.history.push("/login");
          }
        });
    }
  };

  return (
    <div className="setting-container" style={{ minHeight: "90vh" }}>
      <h2 className="setting-title">{t("ویرایش پروفایل")}</h2>

      {/* Profile Image */}
      <div className="profile-image-wrapper">
        <div className="profile-image-container">
          <img
            src={
              userInfo.image !== ""
                ? "https://assessn.mmaviot.com" + userInfo.image
                : avatar
            }
            className="profile-image"
            alt="profile"
          />
          <label className="profile-image-upload">
            <input
              type="file"
              style={{ display: "none" }}
              onChange={(e) => imageSelected(e)}
            />
            <FiCamera size={20} />
          </label>
        </div>
        <p className="profile-name">{userInfo.name}</p>
        <p className="profile-email">{userInfo.email}</p>
      </div>

      {/* Form Section */}
      <Formik initialValues={initialValues} onSubmit={submitUpdateForm}>
        {(formProps) => (
          <Form ref={form}>
            {/* Name Input */}
            <div className="setting-item" style={{ flexDirection: "column", alignItems: "stretch", gap: "12px" }}>
              <div className="setting-item-label">
                <FiUser size={18} />
                <span>{t("نام کاربری")}</span>
              </div>
              <input
                type="text"
                placeholder={t("نام کاربری")}
                value={formProps.values.name}
                name="name"
                onChange={formProps.handleChange}
                onBlur={formProps.handleBlur}
                className="setting-input"
              />
            </div>

            {/* Phone Input */}
            <div className="setting-item" style={{ flexDirection: "column", alignItems: "stretch", gap: "12px" }}>
              <div className="setting-item-label">
                <FiPhone size={18} />
                <span>{t("موبایل")}</span>
              </div>
              <input
                type="tel"
                placeholder={t("موبایل")}
                value={formProps.values.phone}
                name="phone"
                onChange={formProps.handleChange}
                onBlur={formProps.handleBlur}
                className="setting-input"
              />
            </div>

            {/* Email Input - Disabled */}
            <div className="setting-item" style={{ flexDirection: "column", alignItems: "stretch", gap: "12px", opacity: 0.7 }}>
              <div className="setting-item-label">
                <FiMail size={18} />
                <span>{t("ایمیل")}</span>
              </div>
              <input
                type="email"
                placeholder={t("ایمیل")}
                disabled
                value={userInfo.email}
                className="setting-input setting-input-disabled"
              />
            </div>

            {/* Logout All Button */}
            <div className="setting-item logout-item" onClick={logoutAll}>
              <div className="setting-item-label">
                <FiLogOut size={18} />
                <span>{t("خروج از تمام حساب های کاربری")}</span>
              </div>
              <FiArrowRight size={18} />
            </div>

            {/* Action Buttons */}
            <div className="setting-buttons">
              <button
                type="button"
                className="setting-back-btn"
                onClick={() => ProfileShowHideFunc("setting")}
                style={{ background: "var(--bg-white)", color: "var(--text-primary)", border: "2px solid var(--border-color)" }}
              >
                <FiArrowRight size={18} />
                <span>{t("بازگشت")}</span>
              </button>
              <button type="submit" className="setting-back-btn">
                <FiCheck size={18} />
                <span>{t("ذخیره")}</span>
              </button>
            </div>
          </Form>
        )}
      </Formik>

      {showAlert.show && (
        <Alert message={showAlert.message} type={showAlert.type} />
      )}
    </div>
  );
};

const EditProfile = withRouter(EditProfileComp);

export { EditProfile };